import { createRouter, createWebHistory } from '@ionic/vue-router';
import HomePage from '../views/HomePage.vue'
import ImpostazioniPage from '../views/ImpostazioniPage.vue'
import HomePageInformazioni from '../views/HomePageInformazioni.vue'
import InformazioniDet from '../views/InformazioniDet.vue'
import HomePageAttivita from '../views/HomePageAttivita.vue'
import AttivitaLista from '../views/AttivitaLista.vue'
import AttivitaDet from '../views/AttivitaDet.vue'
import SegnalazioniHome from '../views/SegnalazioniHome.vue'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },{
    path: '/Impostazioni',
    name: 'Impostazioni',
    component: ImpostazioniPage
  },{
    path: '/Informazioni',
    name: 'Informazioni',
    component: HomePageInformazioni
  },{
    path:'/InformazioniDet/:pIns_grup',
    name:'InformazioniDet',
    component: InformazioniDet
  },{
    path:'/HomePageAttivita',
    name: 'HomePageAttivita',
    component: HomePageAttivita
  },{
    path: '/AttivitaLista/:pSearch',
    name: 'AttivitaLista',
    component: AttivitaLista
  },{
    path: '/AttivitaDet/:pAtt_Codi',
    name: 'AttivitaDet',
    component: AttivitaDet
  },{
    path: '/SegnalazioniHome',
    name: 'SegnalazioniHome',
    component: SegnalazioniHome
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
